import { useState } from 'react';
import { Handler } from '../common/handler';
import Stave from '../common/extension/MusiconStave';
import PlayCircle from '../assets/icons/play-circle-fill.svg';
import StopCircle from '../assets/icons/stop-circle-fill.svg';
import SingleStaveHandler from "../common/singleStaveHandler";

interface PlayButtonProps {
    handler: SingleStaveHandler | null;
    dataJson: any;
}

export const ListeningPlayButton = ({ handler, dataJson }: PlayButtonProps) => {
    const [img, setImg] = useState(PlayCircle);

    return (
        <div className="play-button-container">
            <img
                className="play-button"
                alt=""
                onClick={() => {
                    if (handler?.playing === true) {
                        handler?.stop();
                        setImg(PlayCircle);
                    } else {
                        handler?.playNotes(dataJson.answer, () => {
                            setImg(PlayCircle);
                        });
                        setImg(StopCircle);
                    }
                }}
                src={img}
            />
        </div>
    );
};
